const moduleName = 'hidden';

export function hidden() {
    document.querySelectorAll('.js-expand-text').forEach((btn) => {
        btn.addEventListener('click', function (){
            btn.previousElementSibling.style.display = 'block';
            btn.remove();
        });
    });
}
